import { combineReducers } from "redux"

import { routerReducer } from "react-router-redux"
import { objectReducer } from "./objectApi"
import { recordReducer } from "./recordApi"
import { pageReducer } from "./pageApi"
import { appReducer } from "./appApi"
import { stackReducer } from "./stackApi"
import { blockReducer } from "./blockApi"
import { actionReducer } from "./actionApi"
import { compoundReducer } from "./compoundApi"
import { templateReducer } from "./templateApi"

const rootReducer = combineReducers({
    routing: routerReducer,
    objects: objectReducer,
    records: recordReducer,
    pages: pageReducer,
    apps: appReducer,
    stacks: stackReducer,
    blocks: blockReducer,
    templates: templateReducer,
    compounds: compoundReducer,
    actions: actionReducer,
})

export default rootReducer



// WEBPACK FOOTER //
// ./src/data/rootReducer.js